import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';
import {t, Trans} from '@lingui/macro';
import debounce from 'lodash.debounce';

import {givePrivacyConsent} from '../../actions/login';
import {loadPrivacyAgreement} from '../../actions/privacyAgreement';
import {isGivingPrivacyConsent} from '../../reducers/ui';
import {getPrivacyAgreement, isPrivacyAgreementLoading} from '../../reducers/privacyAgreement';

import SkillupLogo from '../../components/Icons/SkillupLogo';
import FlatButton from '../../components/FlatButton';
import Button from '../../components/Button';
import CloseIcon from '../../components/Icons/CloseIcon';
import Checkbox from '../../components/Checkbox';
import Loader from '../../components/Loader';

import {LOGIN} from '../../services/routes';
import {i18n} from '@services/i18n';
import {getSuffix} from '@services/utilities';

import cl from 'classnames';
import s from './Privacy.css';

class Privacy extends Component {
  state = {
    consent: false,
  };
  debouncedConfirm = debounce(this.props.givePrivacyConsent, 200);

  componentDidMount() {
    if (!this.props.privacyAgreement) {
      this.props.loadPrivacyAgreement();
    }
  }

  toggleConsent = () => this.setState(({consent}) => ({consent: !consent}));

  goToLoginPage = () => {
    this.props.push(LOGIN);
  };

  render() {
    const {isGivingPrivacyConsent, privacyAgreement, isPrivacyAgreementLoading} = this.props;
    const {consent} = this.state;

    return (
      <div className={cl(s.LoginPage)}>
        <section className={s.PrivacyForm}>
          <div className={s.PrivacyContainer}>
            <section className={s.Header}>
              <div className={s.Logo}>
                <SkillupLogo />
                <span>
                  <Trans id="privacy.modal_title">Termini di utilizzo</Trans>
                </span>
              </div>
              <FlatButton className={s.CloseButton} onClick={this.goToLoginPage}>
                <CloseIcon />
              </FlatButton>
            </section>

            <section className={s.TermsContainer}>
              <h1 className={s.Title}>
                <Trans id="privacy.text">Utilizzo dei miei dati personali</Trans>
              </h1>
              <div className={s.Terms}>
                {isPrivacyAgreementLoading ? (
                  <Loader className={s.Loader} />
                ) : (
                  <div dangerouslySetInnerHTML={{__html: privacyAgreement}} />
                )}
              </div>
            </section>

            <section>
              <Checkbox
                label={i18n._(
                  'privacy.chkbox_info',
                  {},
                  {defaults: "Ho letto e ho preso visione dell'informativa"}
                )}
                className={s.Checkbox}
                labelClassName={s.CheckboxLabel}
                onClick={this.toggleConsent}
                isChecked={consent}
              />
            </section>
          </div>

          <Button
            className={cl(s.SendButton, consent && s.Active)}
            onClick={this.debouncedConfirm}
            disabled={!consent}
            loading={isGivingPrivacyConsent}
          >
            <span>
              <Trans id="privacy.confirm">Conferma</Trans>
            </span>
          </Button>
        </section>

        <p className={s.Copyright}>{`Skillup © ${new Date().getFullYear()} ${getSuffix()}`}</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isGivingPrivacyConsent: isGivingPrivacyConsent(state),
    privacyAgreement: getPrivacyAgreement(state),
    isPrivacyAgreementLoading: isPrivacyAgreementLoading(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({givePrivacyConsent, loadPrivacyAgreement, push}, dispatch);
}

export const ConnectedPrivacy = connect(mapStateToProps, mapDispatchToProps)(Privacy);
